import { defineStore } from 'pinia';

const useMenuStore = defineStore('menu', {
  state: () => ({
    isExpand: false, // Always start collapsed
    actions: {} as Record<string, () => void>,
    isInitializing: true, // Prevent auto-expansion during app initialization
    homeRefreshPending: false,
  }),
  getters: {
    // menuStatus: state => state.isCollapsed,
  },
  actions: {
    setMenuExpand(value: boolean) {
      // Get stack trace to identify caller
      const stack = new Error().stack;
      const caller = stack?.split('\n')[2]?.trim() || 'unknown';

      console.log('[DEBUG] setMenuExpand called:', {
        from: this.isExpand,
        to: value,
        env: process.env.NODE_ENV,
        hostname: typeof window !== 'undefined' ? window.location.hostname : 'unknown',
        caller: caller,
        isInitializing: this.isInitializing,
        fullStack: stack,
      });

      // Prevent expansion during initialization unless explicitly allowed
      if (this.isInitializing && value === true) {
        console.warn('[DEBUG] Preventing menu expansion during initialization - BLOCKED!');
        console.warn('[DEBUG] Blocked expansion caller:', caller);
        console.warn('[DEBUG] Blocked expansion stack:', stack);
        return;
      }

      // Log any successful menu expansion with full context
      if (value === true && !this.isInitializing) {
        console.warn('[DEBUG] ⚠️  MENU EXPANDING - caller:', caller);
        console.warn('[DEBUG] ⚠️  MENU EXPANDING - full stack:', stack);
      }

      this.isExpand = value;
    },
    registerAction(name: string, fn: () => void) {
      this.actions[name] = fn;
    },
    unregisterAction(name: string) {
      delete this.actions[name];
    },
    callAction(name: string) {
      const fn = this.actions[name];
      if (typeof fn === 'function') {
        fn();
      } else {
        console.warn(`未找到已注册的 action: ${name}`);
      }
    },
    setHomeRefreshPending(value: boolean) {
      this.homeRefreshPending = value;
    },
    setInitializing(value: boolean) {
      console.log('[DEBUG] setInitializing called:', {
        from: this.isInitializing,
        to: value,
        env: process.env.NODE_ENV,
        hostname: typeof window !== 'undefined' ? window.location.hostname : 'unknown',
      });
      this.isInitializing = value;
    },
  },
});

export default useMenuStore;
